import React, { useState } from 'react';

import { Form, Button, Typography } from 'antd';

import FeeEventEditModal from './FeeEventEditModal';
import FeeEventsTable from '../Table/FeeEventsTable';
import Spacer from 'components/ui/Spacer';

import { getTranslatedString } from 'helpers/i18n';

const requiredAtLeastOneEvent = {
  validator: async (_, fee_events) => {
    if (!fee_events || fee_events.length < 1) {
      return Promise.reject(new Error(getTranslatedString('landlordPortal.fees.attributes.events.errorMessage')));
    }
  },
};

const FeeEventsForm = () => {
  const form = Form.useFormInstance();
  const [isEditing, setIsEditing] = useState(false);
  const [editingEvent, setEditingEvent] = useState(null);

  const resetEditing = () => {
    setIsEditing(false);
    setEditingEvent(null);
  };

  return (
    <>
      <Typography.Title level={4}>{getTranslatedString('landlordPortal.fees.attributes.events')}</Typography.Title>

      <Form.List name="fee_events" rules={[requiredAtLeastOneEvent]} shouldUpdate>
        {(fields, { add, remove }, { errors }) => {
          const dataSource = fields.map(({ _, name }) => {
            const eventData = {
              ...form.getFieldValue(['fee_events', name]),
              onUpdate: (value) => {
                form.setFields([{ name: ['fee_events', name], value }]);
              },
            };

            return {
              ...eventData,
              onEdit: () => {
                setIsEditing(true);
                setEditingEvent(eventData);
              },
              onDelete: () => remove(name),
            };
          });

          return (
            <>
              <FeeEventsTable dataSource={dataSource} />

              <Spacer mt={1}>
                <Button
                  onClick={() => {
                    const newEvent = { onUpdate: (value) => add(value) };
                    setEditingEvent(newEvent);
                    setIsEditing(true);
                  }}
                >
                  {getTranslatedString('landlordPortal.fees.addEvent')}
                </Button>
              </Spacer>

              <Form.ErrorList errors={errors} />

              <FeeEventEditModal
                visible={isEditing}
                handleClose={resetEditing}
                feeEventData={editingEvent}
              />
            </>
          );
        }}
      </Form.List>
    </>
  );
};

export default FeeEventsForm;
